/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Form } from 'react-bootstrap';

const ChecklistComponent = (props: any) => {
  const { parameters, customisations } = props;
  const checklistItemStyle = {
    paddingTop: customisations.customPaddingtop ? `${customisations.customPaddingtop}px` : '10px',
    paddingLeft: customisations.customPaddingleft
      ? `${customisations.customPaddingleft}px`
      : '10px',
    paddingBottom: customisations.customPaddingbottom
      ? `${customisations.customPaddingbottom}px`
      : '10px',
    paddingRight: customisations.customPaddingright
      ? `${customisations.customPaddingright}px`
      : '10px',
    backgroundColor: customisations.ChecklistBgColor,
    borderStyle: customisations.borderStyle,
    borderColor: customisations.borderColor,
    borderTopWidth: customisations.borderTop ? `${customisations.borderTop}px` : '0px',
    borderBottomWidth: customisations.borderBottom ? `${customisations.borderBottom}px` : '0px',
    borderLeftWidth: customisations.borderLeft ? `${customisations.borderLeft}px` : '0px',
    borderRightWidth: customisations.borderRight ? `${customisations.borderRight}px` : '0px',
    borderRadius: customisations.borderRadius ? `${customisations.borderRadius}px` : '0px',
  };
  const headerStyle = {
    display: 'flex',
    fontFamily: customisations.fontFamily,
    fontSize: `${customisations.fontSize}px`,
    fontStyle: customisations.fontStyle,
    color: customisations.headerFontColor,
    justifyContent: customisations.alignment,
    fontWeight: customisations.fontWeightForHeader,
  };

  const BodyStyle = {
    fontFamily: customisations.bodyFontFamily,
    fontSize: `${customisations.checklistBodyFontSize}px`,
    fontStyle: customisations.checklistBodyFontStyle,
    color: customisations.ChecklistBodyFontColor,
    justifyContent: customisations.checklistBodyAlignment,
    fontWeight: customisations.checklistBodyFontWeight,
  };

  return (
    <div style={checklistItemStyle}>
      {parameters.name && <div style={headerStyle}>{parameters.name}</div>}
      <div className='d-flex align-items-center pt-2' style={BodyStyle}>
        {parameters.checklistItems && parameters.checklistItems.length > 0 ? (
          <ul
            style={{
              listStyleType: 'none',
              paddingLeft: 0,
              width: 'fit-content',
            }}
          >
            {parameters.checklistItems.map((item: any) => {
              const checkboxId = `check-${item.id}`;

              return (
                <li key={item.id} className='d-flex align-items-center gap-2 mb-2'>
                  <Form.Check className='d-flex align-items-center gap-2 p-0'>
                    <input
                      type='checkbox'
                      id={checkboxId}
                      defaultChecked={item.checked}
                      style={{
                        accentColor: customisations.checkBoxColor,
                        cursor: 'pointer',
                      }}
                      onChange={(e) => {
                        const span = document.getElementById(`label-${item.id}`);
                        if (span) {
                          span.style.textDecoration =
                            e.currentTarget.checked && customisations.strike
                              ? 'line-through'
                              : 'none';
                        }
                      }}
                    />

                    <Form.Check.Label
                      htmlFor={checkboxId}
                      id={`label-${item.id}`}
                      style={{
                        cursor: 'pointer',
                        userSelect: 'none',
                        textDecoration:
                          item.checked && customisations.strike ? 'line-through' : 'none',
                        wordBreak: 'break-word',
                      }}
                    >
                      {item.label}
                    </Form.Check.Label>
                  </Form.Check>
                </li>
              );
            })}
          </ul>
        ) : (
          <p style={checklistItemStyle}>No checklist items added</p>
        )}
      </div>
    </div>
  );
};

export default ChecklistComponent;
